export const hourlyGuideLink =
  'https://mp.weixin.qq.com/s?__biz=MzUzMDY3MTkyNg==&mid=2247727279&idx=2&sn=65dd6c417a8c9b1b432a24d1e81163d6&chksm=fa4308f6cd3481e0cafa8124790fe49cfd42129e4087f3da6cb6284f87d52725770262addd86&scene=27'

const baseImagePath = '/hourly'

export const hourlyGuides = [
  {
    hour: 0,
    timeLabel: '00:00 - 00:59',
    label: '子夜',
    title: '子夜清音',
    verse: '歌诀：子夜守静心，暗香伴梦沉。',
    description: '夜色深沉，适合在昏黄灯下整理今日思绪。',
    highlight: '推荐：写下想继续完成的精神任务。',
    image: `${baseImagePath}/hour-00.svg`,
  },
  {
    hour: 1,
    timeLabel: '01:00 - 01:59',
    label: '初更',
    title: '星河微眠',
    verse: '歌诀：初更风息息，星河藏语。',
    description: '星辰尚在安眠，放慢呼吸，听风穿过窗纱。',
    highlight: '推荐：听一段慢语吟唱，舒缓神经。',
    image: `${baseImagePath}/hour-01.svg`,
  },
  {
    hour: 2,
    timeLabel: '02:00 - 02:59',
    label: '漏夜',
    title: '风静漏声',
    verse: '歌诀：漏夜候风来，冷月伴幽栖。',
    description: '大地沉入更深，思绪最易接近无垠。',
    highlight: '推荐：将夜里闪过的灵感写下。',
    image: `${baseImagePath}/hour-02.svg`,
  },
  {
    hour: 3,
    timeLabel: '03:00 - 03:59',
    label: '寅初',
    title: '漏雨清翔',
    verse: '歌诀：寅初漏声细，观心数寒星。',
    description: '微光透窗，梦还未散，针尖般的静默适合内观。',
    highlight: '推荐：盘点一天中值得珍藏的片段。',
    image: `${baseImagePath}/hour-03.svg`,
  },
  {
    hour: 4,
    timeLabel: '04:00 - 04:59',
    label: '晓雾',
    title: '曙光初窥',
    verse: '歌诀：晓雾催曙光，行板渐悠。',
    description: '天边开始泛白，闻到潮湿与叶香。',
    highlight: '推荐：准备一杯清茶，放空心绪。',
    image: `${baseImagePath}/hour-04.svg`,
  },
  {
    hour: 5,
    timeLabel: '05:00 - 05:59',
    label: '初晨',
    title: '晨露初凝',
    verse: '歌诀：初晨露凝重，阳光未央。',
    description: '晨雾柔软，适合带着光影慢走。',
    highlight: '推荐：给亲友发一条温柔消息。',
    image: `${baseImagePath}/hour-05.svg`,
  },
  {
    hour: 6,
    timeLabel: '06:00 - 06:59',
    label: '晨曦',
    title: '晨曦抚叶',
    verse: '歌诀：晨曦迎叶绿，伸展正当。',
    description: '阳光穿越树梢，感受呼吸与心跳。',
    highlight: '推荐：伸展身体，预热四肢。',
    image: `${baseImagePath}/hour-06.svg`,
  },
  {
    hour: 7,
    timeLabel: '07:00 - 07:59',
    label: '旭光',
    title: '旭日微扬',
    verse: '歌诀：旭光满庭院，心事慢排。',
    description: '光芒透窗，城市尚在醒来，心绪邀日做序。',
    highlight: '推荐：列出今日三件小目标。',
    image: `${baseImagePath}/hour-07.svg`,
  },
  {
    hour: 8,
    timeLabel: '08:00 - 08:59',
    label: '晨光',
    title: '朝雾轻扬',
    verse: '歌诀：晨光轻扬起，茶香伴思。',
    description: '街角雾气尚未散，适合慢饮早茶。',
    highlight: '推荐：把工作的优先级写在纸上。',
    image: `${baseImagePath}/hour-08.svg`,
  },
  {
    hour: 9,
    timeLabel: '09:00 - 09:59',
    label: '午前',
    title: '午前静好',
    verse: '歌诀：午前阳渐暖，柔语宜传。',
    description: '阳光开始洒落桌面，节奏稳健。',
    highlight: '推荐：用温柔语气联系一个远方的朋友。',
    image: `${baseImagePath}/hour-09.svg`,
  },
  {
    hour: 10,
    timeLabel: '10:00 - 10:59',
    label: '尚午',
    title: '阳光渐浓',
    verse: '歌诀：尚午清风里，思绪格调。',
    description: '空气里有些干爽，心思更清澈。',
    highlight: '推荐：快速整理上半天成果。',
    image: `${baseImagePath}/hour-10.svg`,
  },
  {
    hour: 11,
    timeLabel: '11:00 - 11:59',
    label: '升午',
    title: '日光斜照',
    verse: '歌诀：升午光斜影，呼吸重返。',
    description: '桌面投下长影，适合做些冥想练习。',
    highlight: '推荐：深呼吸三次，重新聚焦。',
    image: `${baseImagePath}/hour-11.svg`,
  },
  {
    hour: 12,
    timeLabel: '12:00 - 12:59',
    label: '午正',
    title: '午正道',
    verse: '歌诀：午正日当空，行止以中。',
    description: '光正上方，身心在热度中寻找平衡。',
    highlight: '推荐：短暂散步十分钟，让血液回旋。',
    image: `${baseImagePath}/hour-12.svg`,
  },
  {
    hour: 13,
    timeLabel: '13:00 - 13:59',
    label: '午后',
    title: '午后绵延',
    verse: '歌诀：午后轻云绽，感恩记心。',
    description: '太阳仍耀眼但渐有柔软，邀请自己静心。',
    highlight: '推荐：写下今午一点感恩。',
    image: `${baseImagePath}/hour-13.svg`,
  },
  {
    hour: 14,
    timeLabel: '14:00 - 14:59',
    label: '昃日',
    title: '昃日闲谈',
    verse: '歌诀：昃日金光稔，休憩方能。',
    description: '光线变得金黄，适合稍作休息并聆听内心。',
    highlight: '推荐：分享一段亲切的语音与好友。',
    image: `${baseImagePath}/hour-14.svg`,
  },
  {
    hour: 15,
    timeLabel: '15:00 - 15:59',
    label: '下昼',
    title: '余晖拾光',
    verse: '歌诀：下昼余晖重，茶香入梦。',
    description: '热度还在消退，适合一杯花草茶。',
    highlight: '推荐：快速回顾今天学到的新词。',
    image: `${baseImagePath}/hour-15.svg`,
  },
  {
    hour: 16,
    timeLabel: '16:00 - 16:59',
    label: '暮织',
    title: '暮色织影',
    verse: '歌诀：暮织染天涯，默记行迹。',
    description: '天际堆叠橙紫，想起白天的足迹。',
    highlight: '推荐：为晚餐准备一份用心的节律。',
    image: `${baseImagePath}/hour-16.svg`,
  },
  {
    hour: 17,
    timeLabel: '17:00 - 17:59',
    label: '斜阳',
    title: '斜阳归岸',
    verse: '歌诀：斜阳守大道，脚步节律。',
    description: '地面铺满金色，适合慢跑或伸展。',
    highlight: '推荐：记录三件今天让你微笑的小事。',
    image: `${baseImagePath}/hour-17.svg`,
  },
  {
    hour: 18,
    timeLabel: '18:00 - 18:59',
    label: '晚霞',
    title: '晚霞如纱',
    verse: '歌诀：晚霞如纱罩，收心归家。',
    description: '城市灯火初亮，心适合慢慢落地。',
    highlight: '推荐：关闭屏幕，远眺窗外半分钟。',
    image: `${baseImagePath}/hour-18.svg`,
  },
  {
    hour: 19,
    timeLabel: '19:00 - 19:59',
    label: '星火',
    title: '星火初燃',
    verse: '歌诀：星火伴归途，筹划明晨。',
    description: '夜色加深，想象未来的光辉。',
    highlight: '推荐：对照日程表调整明早节奏。',
    image: `${baseImagePath}/hour-19.svg`,
  },
  {
    hour: 20,
    timeLabel: '20:00 - 20:59',
    label: '夜航',
    title: '霜华未降',
    verse: '歌诀：夜航凉露起，语声聊畅。',
    description: '空气微凉，适合回家与家人分享笑语。',
    highlight: '推荐：写下今晚最想实现的温柔小事。',
    image: `${baseImagePath}/hour-20.svg`,
  },
  {
    hour: 21,
    timeLabel: '21:00 - 21:59',
    label: '月影',
    title: '月影清凉',
    verse: '歌诀：月影清凉临，薄荷解忧。',
    description: '月华洒下银色，心绪变得悠远。',
    highlight: '推荐：泡一杯薄荷茶，慢慢品味。',
    image: `${baseImagePath}/hour-21.svg`,
  },
  {
    hour: 22,
    timeLabel: '22:00 - 22:59',
    label: '更深',
    title: '更深沉思',
    verse: '歌诀：更深沉思时，诗句入梦。',
    description: '夜更沉，适合阅读或听诗。',
    highlight: '推荐：读一段短诗，记录喜欢的句子。',
    image: `${baseImagePath}/hour-22.svg`,
  },
  {
    hour: 23,
    timeLabel: '23:00 - 23:59',
    label: '夜归',
    title: '夜归子午',
    verse: '歌诀：夜归怀旧意，温柔入寐。',
    description: '最后一丝灯火在路上，鼓励自己温柔安睡。',
    highlight: '推荐：写下明晨想做的第一件事。',
    image: `${baseImagePath}/hour-23.svg`,
  },
]
